export default "__VITE_ASSET__xkdNFiba__"